import { useToast } from '../../hooks/use-toast';
import { X, CheckCircle, AlertCircle, Info } from 'lucide-react';

export function Toaster() {
  const { toasts, dismiss } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[100] flex flex-col gap-2 pointer-events-none">
      {toasts.map((toast) => {
        const Icon =
          toast.type === 'success' ? CheckCircle : toast.type === 'error' ? AlertCircle : Info;
        const bgColor =
          toast.type === 'success'
            ? 'bg-green-50 border-green-200'
            : toast.type === 'error'
              ? 'bg-red-50 border-red-200'
              : 'bg-blue-50 border-blue-200';
        const textColor =
          toast.type === 'success'
            ? 'text-green-800'
            : toast.type === 'error'
              ? 'text-red-800'
              : 'text-blue-800';
        const iconColor =
          toast.type === 'success'
            ? 'text-green-600'
            : toast.type === 'error'
              ? 'text-red-600'
              : 'text-blue-600';

        return (
          <div
            key={toast.id}
            className={`pointer-events-auto flex items-start gap-3 p-4 rounded-lg border shadow-lg animate-in slide-in-from-right-5 fade-in duration-300 w-80 max-w-full ${bgColor} ${textColor}`}
          >
            <Icon className={`w-5 h-5 shrink-0 ${iconColor}`} />
            <p className="text-sm font-medium leading-relaxed flex-1">{toast.message}</p>
            <button
              onClick={() => dismiss(toast.id)}
              className="shrink-0 ml-2 text-gray-500 hover:text-gray-700 transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
